module.exports = __webpack_public_path__ + "media/images/mailer/check-48-primary-c03f438b0b072175b7b6467f06e5aa2c.png";